import PropTypes from 'prop-types';
import sharedTranslations from 'messages/shared';
import i18n from '@wix/wix-vod-shared/src/common/i18n';

const ComingSoon = ({ className }) => (
  <span className={className}>
    {i18n.t(sharedTranslations.comingSoon)}
  </span>
);

ComingSoon.propTypes = {
  className: PropTypes.string,
};

export default ComingSoon;



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/partials/coming-soon.js